import React from "react";
import "./About.css";
import aboutimge from "../../imges/about-removebg-preview.png";
// import aboutimge from "../../imges/01.png";
import RESUME from "../../imges/mohammad-albahla.pdf";

import { Fade } from "react-awesome-reveal";

function About() {
  return (
    <section id="section2">
      <div className="container">
        <div id="about">
          <div id="aboutImge">
            <Fade delay={0} triggerOnce={true} direction="left">
              <img src={aboutimge} alt="" />
            </Fade>
          </div>

          <div id="aboutText">
            <Fade delay={0} direction="right" triggerOnce={true} cascade>
              <h2>Hi There! I'm muhammed albahle</h2>
              <span>frontEnd developer</span>
              <p>
                A passionate software developer with a proven track record of
                building and maintaining high-quality web applications. I’m a
                multi-skilled and hardworking professional who is eager to
                continuously enhance and expand my expertise. Committed to
                lifelong learning and staying up to date with the latest
                technologies in the field. Currently seeking new challenging
                opportunities that allow me to grow and gain diverse
                experiences.
              </p>
              <ul>
                <li>
                  {" "}
                  <p>Phone:</p>
                  <span> +4917662025331</span>
                </li>
                <li>
                  <p>Language:</p> <span> turkish ,arabic, deutsch </span>
                </li>
                <li>
                  <p>Freelance:</p>
                  <span> Available</span>
                </li>
              </ul>
              <div className="aboutBtns">
                <a href={RESUME} id="Download" download={"muhammed.pdf"}>
                  Download CV
                </a>
                <a href="tel:(+49)17662025331" id="Download" target="_self">
                  call me
                </a>
              </div>
            </Fade>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
